import React from 'react';
import './header.css';
//import logo from '../../../assets/images/prtc-logo.png';
import logo from '../../../assets/images/archtopfiber-logo_color.png';
import { ReactComponent as UserIcon } from '../../../assets/icons/person.svg';
import { HEADER_HEIGHT, THEME } from '../../../utils/constants';
import {
  COMPANY_API_CUSTOMER_ID,
  CUSTOMER_NAME,
  COMPANY_CONFIG,
} from '../../../constants/companyConfig';
const Header = () => {
  // Use domain to determine logo since Interbel uses PRTC's data but different branding
  const domain = COMPANY_CONFIG.domain;
  
  if (domain === 'prtc') {
    logo = require('../../../assets/images/prtc-logo.png');
  } else if (domain === 'archtop') {
    logo = require('../../../assets/images/archtopfiber-logo_color.png');
  } else if (domain === 'highline') {
    logo = require('../../../assets/images/highline.png');
  } else if (domain === 'interbel') {
    logo = require('../../../assets/images/interbel-logo.png');
  } else if (domain === 'acs') {
    logo = require('../../../assets/images/akcs-logo.png');
  }  else if (domain === 'cwf') {
    logo = require('../../../assets/images/clear-wave.png');
  }else {
    //logo = require('../../../assets/images/default-logo.png');
  }
  return (
    <header>
      <div className="header">
    
        <img
  src={logo}
  className={`header-image ${
    domain === 'acs'
      ? 'header-image-acs'
      : domain === 'cwf'
      ? 'header-image-cwf'
      : ''
  }`}
/>

        {/* <div className="header-user">
          <div className="user-wrap">
            <div className="user-icon">
              <UserIcon color={THEME.PRIMARY_COLOR} />
            </div>
            <span className="user-name">Alex</span>
          </div>
        </div> */}
      </div>
      <div style={{ height: `${HEADER_HEIGHT}rem`, width: '100%' }}></div>
    </header>
  );
};

export default Header;
